import React,{forwardRef} from 'react'
import OthersSetupForm from './OthersSetupForm'
const OthersSetupAdd = forwardRef((props, ref) => {
    const {
        formValidateError, 
        othersFormSave, 
        updateOthersData, 
        formData,
        isFormSubmitted
    } = props;
    return (
        <>
            <OthersSetupForm
                formValidateError={formValidateError}
                othersFormSave={othersFormSave}
                updateOthersData={updateOthersData}
                formActionType={'insert'}
                formData={formData}
                isInfoOpenHandler={props.isInfoOpenHandler}
                ref={ref}
                isFormSubmitted={isFormSubmitted}
                isRefresh={props.isRefresh}
            />
        </>
    )
})

export default OthersSetupAdd